

































import { Vue, Component, Prop } from 'vue-property-decorator'
import { PlanRunStatusAll } from '@/components/index'
@Component({
  components: {
    PlanRunStatusAll
  }
})
export default class DetailHeadTitle extends Vue {
  @Prop() datailHead!: any
}
